document.addEventListener('click', async function (event) {
  const button = event.target.closest('[data-show-more]');

  if (!button || button.disabled) return;

  const wrapper = button.closest('[data-show-more-wrapper]');
  const grid = document.querySelector('#product-grid');
  const nextUrl = button.dataset.nextUrl;

  if (!grid || !nextUrl) return;

  const text = button.querySelector('[data-show-more-text]');
  const loading = button.querySelector('[data-show-more-loading]');

  button.disabled = true;

  if (text) text.hidden = true;
  if (loading) loading.hidden = false;

  try {
    const response = await fetch(nextUrl);

    if (!response.ok) {
      throw new Error('Unable to load next page');
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const nextGrid = doc.querySelector('#product-grid');

    if (!nextGrid) {
      throw new Error('Product grid not found');
    }

    Array.from(nextGrid.children).forEach(function (product) {
      grid.appendChild(product);
    });

    const nextButton = doc.querySelector('[data-show-more]');

    if (nextButton && nextButton.dataset.nextUrl) {
      button.dataset.nextUrl = nextButton.dataset.nextUrl;

      button.disabled = false;

      if (text) text.hidden = false;
      if (loading) loading.hidden = true;
    } else {
      wrapper.remove();
    }
  } catch (error) {
    console.error('Show More:', error);

    button.disabled = false;

    if (text) text.hidden = false;
    if (loading) loading.hidden = true;
  }
});